module.exports = __webpack_public_path__ + "static/img/11.dae8c37.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/4/zh/11.png
// module id = d84r
// module chunks = 0